import { render } from "./GenbaList.vue?vue&type=template&id=62ed48bc&scoped=true"
import script from "./GenbaList.vue?vue&type=script&lang=js"
export * from "./GenbaList.vue?vue&type=script&lang=js"

import "./GenbaList.vue?vue&type=style&index=0&id=62ed48bc&scoped=true&lang=css"

import exportComponent from "/Users/asatokazu/Documents/dev/project/sms/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ed48bc"]])

export default __exports__